import { initialVendorNotifications } from "../../../mocks/notificationsMock";
import { parseNotificationsListResponse } from "../../schemas/notificationsSchemas";

const MOCK_CREATED_AT_ISO = [
  "2025-01-10T10:00:00.000Z",
  "2025-01-08T09:30:00.000Z",
  "2025-01-05T14:15:00.000Z",
  "2025-01-02T11:00:00.000Z",
  "2024-12-15T16:45:00.000Z",
  "2024-12-01T08:00:00.000Z",
];

function uiToApiList(items) {
  return items.map((n, i) => ({
    id: String(n.id),
    title: n.title,
    content: n.description ?? "",
    type: "other",
    state: n.archived ? "archived" : n.isRead ? "read" : "not-read",
    createdAt: MOCK_CREATED_AT_ISO[i] ?? new Date().toISOString(),
  }));
}

export const mockNotificationsProvider = {
  list: async (payload) => {
    const { page = 0, size = 20, state } = payload ?? {};
    const all = uiToApiList(initialVendorNotifications.map((n) => ({ ...n })));
    let filtered = all;
    if (state === "archived") {
      filtered = all.filter((x) => x.state === "archived");
    } else if (state === "not-read") {
      filtered = all.filter((x) => x.state === "not-read");
    } else {
      filtered = all.filter((x) => x.state !== "archived");
    }
    const slice = filtered.slice(page * size, page * size + size);
    const body = {
      items: slice,
      totalCount: filtered.length,
      page,
      size,
    };
    parseNotificationsListResponse(body);
    return { data: body };
  },
  state: async () => ({ data: { updated: 1 } }),
};
